(() => {
  const timezoneList = document.querySelectorAll('.time_zone_list__item');
  const modalClose = (target) => {
    let close = target.querySelector('[data-modal-close]');
    close.click();
  }

  if (timezoneList) {
    timezoneList.forEach(item => {
      item.addEventListener('click', () => {
        if (!item.dataset.value && !item.dataset.for) return;

        let timezone = item.dataset.value;
        let target = item.dataset.for;
        let timezoneLabel = document.getElementById(target);

        if (timezoneLabel) {
          timezoneLabel.innerHTML = timezone;
          item.closest('.modal') && modalClose(item.closest('.modal'));
        }
      }, false);
    });
  }
})();
